var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49896 10.7495H14.501C15.0536 10.7495 15.5015 11.1974 15.5015 11.7499V13.0004C15.5015 14.2436 14.4937 15.2514 13.2505 15.2514H10.7495C9.50632 15.2514 8.49854 14.2436 8.49854 13.0004V11.7499C8.49854 11.1974 8.94644 10.7495 9.49896 10.7495Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0352 10.7495V8.49854",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9648 10.7495V8.49854",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0017 20.0544C19.9743 18.0781 21.9131 13.5008 20.5688 9.27234C19.2245 5.04384 14.9984 2.42657 10.6139 3.10715C6.22933 3.78773 2.99547 7.56296 2.99625 12C2.99414 14.486 3.98193 16.8705 5.74139 18.6268V18.6268C7.05063 19.9311 8.82337 20.6636 10.6714 20.6636V20.6636C11.405 20.6631 11.9994 20.0686 12 19.3351V15.2514",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricIcon);
export default __webpack_public_path__ + "static/media/ElectricIcon.02fd82c2da91f315dae6752e0d5e26ea.svg";
export { ForwardRef as ReactComponent };